<div class="row">
    <div class="col-24 d-flex justify-content-between">
        <a (click)="navigateBack()" (keydown.enter)="navigateBack()" role="button" tabindex="0">
            <div class="text" [innerHTML]="backText | safeHtml"></div>
            <div class="icon"></div>
        </a>
        <div class="logo-small" routerLink="/"></div>
    </div>
</div>
